<template>
  <div>
    <wc-data-box
      :title='title'
      :titleIcon='$store.state.icons.modules.clients.icon'
      titleIconColor='grey darken-2'
      :loading='isLoading'
      showHelp
      :helpText='helpText'
    >
      <v-simple-table dense v-if='contacts.length'>
        <tbody>
          <tr v-for='(contact, index) in contacts' :key='index'>
            <td :class='label'></td>
            <td :class='dataValue'>
              {{ contact.name_display }}
              <v-btn icon small @click="contactCard(contact)">
                <v-icon color='grey'>{{ contactIcon }}</v-icon>
              </v-btn>
            </td>
          </tr>
        </tbody>
      </v-simple-table>
      <v-card-text v-else>None found...</v-card-text>
    </wc-data-box>

    <wc-contact-card
      :contact='contact'
      :showDialog='showCard'
      @close='closeCard'
    ></wc-contact-card>

  </div>
</template>

<script>
import _ from 'lodash'
import clientsAPI from '@/modules/clients/api/clients'
import WCContactCardDialog from '@/components/dialogs/WCContactCardDialog'

export default {
  name: 'works-for',
  props: {
    client: {
      required: true
    }
  },
  data: () => ({
    isLoading: false,
    contacts: [],
    showCard: false,
    contactIcon: 'mdi-account-circle',
    label: 'grey--text',
    dataValue: 'text-right pr-2',
    title: 'Works for this company',
    contact: {},
    helpText: 'Individuals who work for this company (as defined on their contact page in the basics box)<br><br>Open client record to edit'
  }),
  mounted () {
    this.getContacts()
  },
  methods: {
    async getContacts () {
      this.isLoading = true
      this.contacts = await clientsAPI.getWorksForClients(this.client.id)
      this.isLoading = false
    },
    contactCard (contact) {
      this.contact = _.cloneDeep(contact)
      this.contact.contact_type = 'Works for ' + this.client.name_display
      this.showCard = true
    },
    closeCard () {
      this.showCard = false
    }
  },
  components: {
    'wc-contact-card': WCContactCardDialog
  }
}
</script>